import catalog from '../config/employeePermissions.json';
import type { EmployeePermissions } from '../types/employee';

export const PERMISSION_CATEGORIES = catalog;
type Matrix = Record<string, Record<string, boolean> | undefined>;

export function hasAssignedPermission(permissions: unknown, category: string, action: string): boolean {
  const matrix = (permissions || {}) as Matrix;
  if (matrix[category] != null) return matrix[category]?.[action] === true;
  const definition = catalog.find(item => item.key === category);
  const fallback = (definition?.legacy as Record<string, string | string[] | boolean> | undefined)?.[action];
  if (typeof fallback === 'boolean') return fallback;
  return (Array.isArray(fallback) ? fallback : fallback ? [fallback] : []).some(path => {
    const [key, legacyAction] = path.split('.');
    return matrix[key]?.[legacyAction] === true;
  });
}

export function normalizePermissions(permissions: unknown = {}): EmployeePermissions {
  return Object.fromEntries(catalog.map(({ key, actions }) => [key,
    Object.fromEntries(actions.map(action => [action, hasAssignedPermission(permissions, key, action)]))
  ])) as unknown as EmployeePermissions;
}

export function emptyPermissions(): EmployeePermissions {
  return Object.fromEntries(catalog.map(({ key, actions }) => [key,
    Object.fromEntries(actions.map(action => [action, false]))
  ])) as unknown as EmployeePermissions;
}
